/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import React, { Fragment } from 'react'

/**
 * Renders a dash without breaking spaces around.
 */
export const SeparatorDash: React.FC = () => {
  return <Fragment>&nbsp;–&nbsp;</Fragment>
}
